import React, { useState } from 'react';
import '../styles/settings.css';

function SettingsModal({ onClose, onSave, editPerson }) {
  const [formData, setFormData] = useState(editPerson || {
    code: '',
    name: '',
    tc: '',
    birth: '',
    addr: '',
    phone: '',
    routingNum: '',
    accountNum: '',
    bankPass: '',
    hasCenoaFee: false,  // Cenoa kesintisi
    cardNum: '',
    cardExp: '',
    cardCVV: '',
    crypto: '',
    srvIP: '',
    srvPass: '',
    stores: Array.from({ length: 10 }, (_, i) => ({
      num: i + 1,
      email: '',
      pass: ''
    }))
  });

  const isEditMode = !!editPerson;

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleStoreChange = (index, field, value) => {
    const newStores = [...formData.stores];
    newStores[index][field] = value;
    setFormData({ ...formData, stores: newStores });
  };

  const handleSubmit = () => {
    // Validation
    if (!formData.code || !formData.name) {
      alert('Code and Name are required!');
      return;
    }

    onSave(formData);
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{isEditMode ? '✏️ Edit Person' : '➕ Add New Person'}</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="modal-body">
          {/* Basic Info */}
          <div className="form-section">
            <h3 className="section-title">👤 Basic Information</h3>
            <div className="form-grid">
              <div className="form-field">
                <label>Code *</label>
                <input
                  type="text"
                  placeholder="001"
                  value={formData.code}
                  onChange={(e) => handleChange('code', e.target.value)}
                  maxLength="3"
                  disabled={isEditMode}
                  style={isEditMode ? {opacity: 0.5, cursor: 'not-allowed'} : {}}
                />
              </div>
              <div className="form-field">
                <label>Full Name *</label>
                <input
                  type="text"
                  placeholder="Ahmet Yılmaz"
                  value={formData.name}
                  onChange={(e) => handleChange('name', e.target.value)}
                />
              </div>
              <div className="form-field">
                <label>TC Kimlik No</label>
                <input
                  type="text"
                  placeholder="12345678901"
                  value={formData.tc}
                  onChange={(e) => handleChange('tc', e.target.value)}
                  maxLength="11"
                />
              </div>
              <div className="form-field">
                <label>Birth Date</label>
                <input
                  type="text"
                  placeholder="15.03.1985"
                  value={formData.birth}
                  onChange={(e) => handleChange('birth', e.target.value)}
                />
              </div>
              <div className="form-field full-width">
                <label>Address</label>
                <input
                  type="text"
                  placeholder="Atatürk Cad. No:123, Istanbul"
                  value={formData.addr}
                  onChange={(e) => handleChange('addr', e.target.value)}
                />
              </div>
              <div className="form-field">
                <label>Phone</label>
                <input
                  type="text"
                  placeholder="+90 555 123 4567"
                  value={formData.phone}
                  onChange={(e) => handleChange('phone', e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* Bank Info */}
          <div className="form-section">
            <h3 className="section-title">🏦 Cenoa Bank Information</h3>
            <div className="form-grid">
              <div className="form-field">
                <label>Routing Number</label>
                <input
                  type="text"
                  placeholder="021000021"
                  value={formData.routingNum}
                  onChange={(e) => handleChange('routingNum', e.target.value)}
                />
              </div>
              <div className="form-field">
                <label>Account Number</label>
                <input
                  type="text"
                  placeholder="123456789012"
                  value={formData.accountNum}
                  onChange={(e) => handleChange('accountNum', e.target.value)}
                />
              </div>
              <div className="form-field">
                <label>Bank Password</label>
                <input
                  type="text"
                  placeholder="Cenoa@Main2024"
                  value={formData.bankPass}
                  onChange={(e) => handleChange('bankPass', e.target.value)}
                />
              </div>
            </div>
            <div style={{marginTop: '12px', padding: '12px', background: 'rgba(212, 175, 55, 0.08)', borderRadius: '8px', border: '1px solid rgba(212, 175, 55, 0.2)'}}>
              <label style={{display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', fontSize: '14px', color: '#d4af37'}}>
                <input
                  type="checkbox"
                  checked={formData.hasCenoaFee || false}
                  onChange={(e) => handleChange('hasCenoaFee', e.target.checked)}
                  style={{width: '18px', height: '18px', cursor: 'pointer', accentColor: '#d4af37'}}
                />
                <span style={{fontWeight: '600'}}>Cenoa kesintisi var (%0.5)</span>
              </label>
            </div>
          </div>

          {/* Card Info */}
          <div className="form-section">
            <h3 className="section-title">💳 Credit Card</h3>
            <div className="form-grid">
              <div className="form-field">
                <label>Card Number</label>
                <input
                  type="text"
                  placeholder="5234567890123456"
                  value={formData.cardNum}
                  onChange={(e) => handleChange('cardNum', e.target.value)}
                  maxLength="16"
                />
              </div>
              <div className="form-field">
                <label>Expiry Date</label>
                <input
                  type="text"
                  placeholder="12/27"
                  value={formData.cardExp}
                  onChange={(e) => handleChange('cardExp', e.target.value)}
                  maxLength="5"
                />
              </div>
              <div className="form-field">
                <label>CVV</label>
                <input
                  type="text"
                  placeholder="456"
                  value={formData.cardCVV}
                  onChange={(e) => handleChange('cardCVV', e.target.value)}
                  maxLength="3"
                />
              </div>
              <div className="form-field full-width">
                <label>Crypto Wallet Address</label>
                <input
                  type="text"
                  placeholder="0xa1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9b0"
                  value={formData.crypto}
                  onChange={(e) => handleChange('crypto', e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* Server Info */}
          <div className="form-section">
            <h3 className="section-title">🖥️ Server Information</h3>
            <div className="form-grid">
              <div className="form-field">
                <label>Server IP</label>
                <input
                  type="text"
                  placeholder="192.168.1.100"
                  value={formData.srvIP}
                  onChange={(e) => handleChange('srvIP', e.target.value)}
                />
              </div>
              <div className="form-field">
                <label>Server Password</label>
                <input
                  type="text"
                  placeholder="Server@2024!Secure"
                  value={formData.srvPass}
                  onChange={(e) => handleChange('srvPass', e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* Stores */}
          <div className="form-section">
            <h3 className="section-title">🏪 Stores (10)</h3>
            <div className="stores-form">
              {formData.stores.map((store, index) => (
                <div key={index} className="store-form-item">
                  <div className="store-form-num">Store #{index + 1}</div>
                  <div className="store-form-fields">
                    <input
                      type="text"
                      placeholder="store1@example.com"
                      value={store.email}
                      onChange={(e) => handleStoreChange(index, 'email', e.target.value)}
                    />
                    <input
                      type="text"
                      placeholder="StorePass1@2024"
                      value={store.pass}
                      onChange={(e) => handleStoreChange(index, 'pass', e.target.value)}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-cancel" onClick={onClose}>Cancel</button>
          <button className="btn-save" onClick={handleSubmit}>
            {isEditMode ? '💾 Update Person' : '💾 Save Person'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SettingsModal;